import { createTheme } from "@mui/material/styles";

/**
 * Sovra Identity App Theme
 * Based on s2c-app Sovra brand colors
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: "#CF0C49", // Raspberry - Primary brand color
      dark: "#A00A3A", // Darker Raspberry
      light: "#F58657", // Peach - lighter primary variant
    },
    secondary: {
      main: "#2A6DA6", // Azur - Secondary brand color
      dark: "#222745", // Midnight - darker secondary
      light: "#B7D3EE", // Sky - lighter secondary
    },
    success: {
      main: "#16A34A", // green-600
      dark: "#15803D", // green-700
      light: "#4ADE80", // green-400
    },
    warning: {
      main: "#FFC057", // Mango - Tertiary color
      dark: "#E6A84D", // Darker Mango
      light: "#FFD89B", // Lighter Mango
    },
    error: {
      main: "#FF2762", // Coral - Tertiary color for errors
      dark: "#CF0C49", // Raspberry - darker error
      light: "#FF6B8F", // Lighter Coral
    },
    info: {
      main: "#2A6DA6", // Azur - Secondary color for info
      dark: "#1F5280", // Darker Azur
      light: "#B7D3EE", // Sky - lighter info
    },
    background: {
      default: "#F1EEED", // Stone - Primary background
      paper: "#FFFFFF", // White for paper/cards
    },
    text: {
      primary: "#222745", // Midnight - Primary text color
      secondary: "#6B7280", // Gray for secondary text
    },
    grey: {
      50: "#F1EEED", // Stone
      100: "#D5CFCD", // Clay
      200: "#B7D3EE", // Sky
      300: "#9CA3AF",
      400: "#6B7280",
      500: "#4B5563",
      600: "#374151",
      700: "#222745", // Midnight
      800: "#1F2937",
      900: "#111827",
    },
  },
  typography: {
    fontFamily: '"Red Hat Display", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.125rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: "0.875rem",
    },
    caption: {
      fontSize: "0.75rem",
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Edge draws its own reveal eye next to ours on password fields
        'input[type="password"]::-ms-reveal, input[type="password"]::-ms-clear':
          {
            display: "none",
          },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: "1px solid #D5CFCD",
        },
      },
    },
  },
});

export default theme;
